// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"342":"77869965","697":"6d2b60a9"}[chunkId] || chunkId) + "." + {"62":"3f846e11b20bf0e6","342":"73a4a097aadb3f2a","697":"712e75004f34b9f6"}[chunkId] + ".js";
};